// src/broadcast-contract.ts —— Bot 广告推送（2026-10-21 拍板，迁移 0049）代理端契约入口：类型一律取 shared/src/api/types（Bc*），
// 路由一律取 shared/src/api/routes（ROUTES 已登记，routes.contract.test 与后端 TestRouteContract 双向核对）。
// 传输只委托正式 ApiClient（api.call / api.blob）：鉴权、401 续期、会话终止、X-Activity: passive 均由其统一处理。
// 调用方只经 bcCall / bcBlob（路由 key 收窄到代理端推广推送集合，误用其他路由在编译期报错）。
import type { ApiClient, CallOptions } from '../../shared/src/api/client';
import type { RouteKey } from '../../shared/src/api/routes';
import type { BcPage } from '../../shared/src/api/types';

export type {
  BcBotOption,
  BcButton,
  BcCampaign,
  BcCampaignInput,
  BcDelivery,
  BcDeliveryStatus,
  BcEstimate,
  BcFile,
  BcFilterCard,
  BcFilterLang,
  BcLastRun,
  BcPage,
  BcQuota,
  BcRun,
  BcRunStatus,
  BcSchedule,
  BcScheduleKind,
  BcStatus,
} from '../../shared/src/api/types';

// 代理端推广推送路由（shared ROUTES 子集；无 export / approve / reject / settings）
export type BcRoute = Extract<RouteKey, `${string} /api/agent/broadcast${string}` | 'GET /api/agent/files/broadcast/{id}'>;

// 分页列表取 list（AdminPage）；后端异常省略时按空列表处理
export function pageItems<T>(p: BcPage<T> | null | undefined): T[] {
  return Array.isArray(p?.list) ? p.list : [];
}

export function bcCall<T>(api: ApiClient, route: BcRoute, o: CallOptions = {}): Promise<T> {
  return api.call<T>(route, o);
}

export function bcBlob(api: ApiClient, route: BcRoute, o: CallOptions = {}): Promise<{ blob: Blob; filename: string | null }> {
  return api.blob(route, o);
}
